import * as React from 'react';
import { ArticleHeading0 } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { About as AboutComponent } from '../../components/About';
import { Layout } from '../../components/Layout';
import { getName } from '../../selectors/newbuilding';
import { NewbuildingBrochureContainer } from '../NewbuildingBrochure';
import { NewbuildingDescriptionContainer } from '../NewbuildingDescription';

export const About = () => {
  const name = useSelector(getName);

  return (
    <Layout>
      <AboutComponent
        title={<ArticleHeading0 as="h2">{`О жилом комплексе «${name}»`}</ArticleHeading0>}
        description={<NewbuildingDescriptionContainer />}
        brochure={<NewbuildingBrochureContainer />}
      />
    </Layout>
  );
};

About.displayName = 'About';
